import { DefaultValues, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useAlert } from 'shared/components/alerts/use-alert';
import { useTranslation } from 'react-i18next';
import { useZodSchema } from 'shared/hooks';
import { useUploadCertificates } from './use-upload-certificates';
import { AccreditationType } from './types';
import { createCertificateUploadSchema } from '../schema';
import { CertificateUploadFormValues } from '../types';

export function useCertificateUploadForm(workerId: string) {
  const { t } = useTranslation('web-common');
  const schema = useZodSchema(createCertificateUploadSchema, 'web-common');

  const defaultValues: DefaultValues<CertificateUploadFormValues> = {
    accreditationType: undefined,
    certificate: undefined,
    certificateFile: undefined,
    termsAndConditionsAccepted: false,
    workerId,
  };

  const form = useForm<CertificateUploadFormValues>({
    resolver: zodResolver(schema),
    defaultValues,
    mode: 'onChange',
  });

  const { mutate: uploadCertificates } = useUploadCertificates();
  const { alertSuccess, alertError } = useAlert();

  const onSubmit = (data: CertificateUploadFormValues) => {
    uploadCertificates(
      {
        accreditationType: data.accreditationType as AccreditationType,
        certificate: data.certificate,
        files: data.certificateFile,
        workerId: data.workerId,
      },
      {
        onSuccess: () => {
          form.resetField('certificate');
          form.resetField('certificateFile');
          form.resetField('accreditationType');
          alertSuccess(t('upload-certificate-screen.form.success-message'));
        },
        onError: (error) => {
          alertError(error);
        },
      }
    );
  };

  return { form, onSubmit };
}
